import { FilterBar } from '@/components/ui/FilterBar';
import * as React from 'react';

const ENABLED_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Enabled' },
  { value: 'false', label: 'Disabled' },
];

export interface CategoriesFiltersProps {
  searchTerm: string;
  selectedEnabled: string;
  onSearchChange: (value: string) => void;
  onEnabledChange: (value: string) => void;
  onClearFilters: () => void;
}

export const CategoriesFilters: React.FC<CategoriesFiltersProps> = ({
  searchTerm,
  selectedEnabled,
  onSearchChange,
  onEnabledChange,
  onClearFilters,
}) => {
  return (
    <FilterBar
      searchPlaceholder='Search categories by name...'
      searchValue={searchTerm}
      onSearchChange={onSearchChange}
      filters={[{ key: 'enabled', label: 'Status', options: ENABLED_OPTIONS }]}
      filterValues={{ enabled: selectedEnabled }}
      onFilterChange={(key, value) => {
        if (key === 'enabled') onEnabledChange(value);
      }}
      onClearAll={onClearFilters}
      activeFilters={[
        { label: 'Search', value: searchTerm, color: 'blue' },
        {
          label: 'Status',
          value: selectedEnabled
            ? selectedEnabled === 'true'
              ? 'Enabled'
              : 'Disabled'
            : '',
          color: 'green',
        },
      ]}
    />
  );
};
